import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ClientSearchPipe', pure: false })
export class ClientSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(client => {
          return client.name.search(searchText) !== -1
			  || client.lastname.search(searchText) !== -1
			  || client.username.search(searchText) !== -1;
      });
    }
  }
}